import React from "react";
import { Spin } from "antd";
import AccessDenied from "./AccessDeniedView/AccessDenied";
import { useCurrentUser } from "../hooks/useCurrentUser";

interface RoleProtectedProps {
  allowedRoles: string[];
  children: React.ReactNode;
  showPageAction?: string;
}

const RoleProtected: React.FC<RoleProtectedProps> = ({
  allowedRoles,
  children,
  showPageAction,
}: RoleProtectedProps) => {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Spin size="large" />
      </div>
    );
  }

  const roleName = currentUser?.roleName ?? null;
  const hasRole = !!roleName && allowedRoles.includes(roleName);
  // Admin bypasses page-action gates the same way it bypasses everything
  // else (see actions_registry.py); everyone else needs the action itself.
  const hasPageAction =
    !showPageAction ||
    roleName === "Admin" ||
    (currentUser?.allowedActions?.includes(showPageAction) ?? false);

  if (!hasRole || !hasPageAction) return (<AccessDenied />);

  return <>{children}</>;
};

export { RoleProtected };
export default RoleProtected;
